var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10817",
    "data-name": "Group 10817",
    transform: "translate(-370.252 -319.273)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9278",
    "data-name": "Rectangle 9278",
    width: 42,
    height: 42,
    rx: 21,
    transform: "translate(370.252 319.273)",
    fill: "#e9edef",
    opacity: 0.553
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10825",
    "data-name": "Group 10825"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9280",
    "data-name": "Rectangle 9280",
    width: 22,
    height: 22,
    transform: "translate(380.252 329.273)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10823",
    "data-name": "Group 10823",
    transform: "translate(383.252 332.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10824",
    "data-name": "Group 10824",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23827",
    "data-name": "Path 23827",
    d: "M14.638,0H2.311A2.311,2.311,0,0,0,0,2.311v7.7a2.311,2.311,0,0,0,2.311,2.311h.77v3.082a.77.77,0,0,0,1.24.609l4.746-3.69h5.57a2.311,2.311,0,0,0,2.311-2.311v-7.7A2.311,2.311,0,0,0,14.638,0m.77,10.015a.771.771,0,0,1-.77.77H8.806a.775.775,0,0,0-.47.162l-3.713,2.92V11.556a.771.771,0,0,0-.77-.77H2.311a.771.771,0,0,1-.77-.77v-7.7a.771.771,0,0,1,.77-.77H14.638a.771.771,0,0,1,.77.77Z",
    transform: "translate(0 0)",
    fill: "#7c8891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23828",
    "data-name": "Path 23828",
    d: "M5.77,6.541h4.622a.77.77,0,0,0,0-1.541H5.77a.77.77,0,1,0,0,1.541",
    transform: "translate(-1.148 -1.148)",
    fill: "#7c8891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23829",
    "data-name": "Path 23829",
    d: "M13.474,9H5.77a.77.77,0,1,0,0,1.541h7.7a.77.77,0,1,0,0-1.541",
    transform: "translate(-1.148 -2.066)",
    fill: "#7c8891"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportar);
export default __webpack_public_path__ + "static/media/reportar.4dc1bcd653f4abd9325e58f0fb7cfabc.svg";
export { ForwardRef as ReactComponent };